
import React, { Component } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import Loader from 'react-loader-spinner';

class MyLeads extends Component {
    constructor() {
        super();

        this.dialogClose = () => {
            this.setState({
                hideupdateDialog: false, hideAddDialog: false, hideDeletePopup: false,
                hideScriptIgnore: false, hideDeleteAllPopup: false, hideIncorrectPassword: false
            });
        };
        this.DeletedialogClose = () => {
            this.setState({ hideTextAreaPopup: false });
        };
        this.IncorrectPassworddialogClose = () => {
            this.setState({ hideIncorrectPassword: false });
        };
        this.settings = { effect: 'Zoom', duration: 400, delay: 0 };
        //for delete success
        this.deleteSuccessbuttons = [{
            buttonModel: {
                content: 'Ok',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.dialogInstance.hide();
                this.fetchLeadDetails()
                this.setState({ disabled: false })
            }
        }];
        //for update dialog component ok click
        this.Okbutton = [{
            buttonModel: {
                content: 'OK',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.fetchLeadDetails()
                this.dialogClose();
            }
        }];
        this.addedButton = [{
            buttonModel: {
                content: 'OK',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.fetchLeadDetails()
                this.dialogClose();
                this.setState({
                    disabled: false
                })
            }
        }];
        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.deleteLeadApi(this.state.propsId)
                this.setState({ disabled: false })

            }
        }
            , {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideDeletePopup: false,
                    disabled: false
                });
            }
        }];

        this.editImageSrc = "./assets/images/edit2.png";
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";

        this.state = {
            successResp: false,
            editImageSrc: './assets/images/edit.svg',
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
            contentEditable: "false",
            editedId: '-1',
            leadId: null,
            data: [],
            maskLeadNumbers: false
        }
    }

    componentDidMount() {
        var leadController = this;

        setTimeout(() => {
            leadController.fetchAdvanceProperties();
            leadController.fetchLeadDetails();
        }, 300);

        document.addEventListener("projectChanged", function (event) {
            leadController.fetchAdvanceProperties();
            leadController.fetchLeadDetails();
        });
    }

    fetchAdvanceProperties = () => {
        var advancePropertyController = this;
        $.ajax({
            url: "/salesdesk-api/advance-properties",
            async: false,
            method: 'GET',
            data: {
                projectId: localStorage.getItem('currentProjectId'),
            },
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    var properties = res.result;
                    if (properties != null) {
                        for (var i = 0; i < properties.length; i++) {
                            var projectRole = localStorage.getItem('PROJECT_ROLE');

                            if (properties[i].advancePropertyName == "MASK_LEAD_NUMBERS_FOR_SUPPORT_USERS") {
                                if (properties[i].advancePropertyValue != null && properties[i].advancePropertyValue
                                    && projectRole == "PROJECT_SUPPORT_USER") {
                                    advancePropertyController.state.maskLeadNumbers = true;

                                } else {
                                    advancePropertyController.state.maskLeadNumbers = false;
                                }
                            }
                        }
                    }
                    advancePropertyController.setState(advancePropertyController.state);

                } else {
                    advancePropertyController.notifyError(res.result);
                }
            },
            error: function (xhr) {
                var errorMessage = xhr.status + ': ' + xhr.statusText
                if (xhr.status == 401) {
                    window.location.href = "/sales-desk/login";
                }
            }
        });
    }

    fetchLeadDetails = () => {

        var leadController = this;
        leadController.setState({ data: []});
        $.ajax({
            url: "/salesdesk-api/fetch-leads-by-executive-id",
            async: false,
            method: 'POST',
            data: {
                projectId: localStorage.getItem('currentProjectId'),
                salesExecutiveId: JSON.parse(localStorage.getItem("user_details")).userId
            },
            headers: {

                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    leadController.state.data = res.result;
                    leadController.state.editedId = '-1';
                    leadController.setState(leadController.state);
                } else {
                    leadController.notifyError(res.result);
                }
            },
            error: function (xhr) {
                var errorMessage = xhr.status + ': ' + xhr.statusText
                if (xhr.status == 401) {
                    window.location.href = "/sales-desk/login";
                }
            }
        });
    }

    fetchLeadByContactNumber = () => {

        var leadController = this;

        var contactNumber = document.getElementById('contactNumber').value;
        if (!contactNumber.includes("+91")) {
            contactNumber = "+91" + contactNumber;
        }
        var leadData = [];
        $.ajax({
            url: "/salesdesk-api/fetch-lead-by-contact-number",
            async: false,
            method: 'POST',
            data: {
                projectId: localStorage.getItem('currentProjectId'),
                contactNumber: contactNumber
            },
            headers: {

                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    if (res.result != null) {
                        leadData.push(res.result);
                        leadController.state.data = leadData;
                        leadController.setState(leadController.state);

                    } else {
                        leadController.notifyLeadNotPresent("Lead not found!");
                    }

                } else {
                    leadController.notifyError(res.result);
                }
            },
            error: function (xhr) {
                var errorMessage = xhr.status + ': ' + xhr.statusText
                if (xhr.status == 401) {
                    window.location.href = "/sales-desk/login";
                }
            }
        });
    }


    updateLeadApi(props, e) {
        
        var contactNumber = document.getElementById("contactNumber" + props.index).innerText.trim();
        if(contactNumber.includes('X')){
            contactNumber = props.original.contactNumber;
        }
        props.original.name = document.getElementById("name" + props.index).innerText.trim();
        props.original.contactNumber = contactNumber;
        props.original.email = document.getElementById("email" + props.index).innerText.trim();
        props.original.title = document.getElementById("title" + props.index).innerText.trim();
        props.original.companyName = document.getElementById("companyName" + props.index).innerText.trim();
        props.original.enterpriseCrmId = document.getElementById("enterpriseCrmId" + props.index).innerText.trim();



        var validateResult = this.validateCells(props.original.code)
        if (validateResult == true) {

            var updatedData = {
                id: props.original.id,
                name: props.original.name,
                contactNumber: props.original.contactNumber,
                email: props.original.email,
                title: props.original.title,
                companyName: props.original.companyName,
                enterpriseCrmId: props.original.enterpriseCrmId
            };
            var updatedDataController = this
            $.ajax({
                url: "/salesdesk-api/update-lead-details",
                async: false,
                method: 'PATCH',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json',

                },
                data: JSON.stringify(updatedData),
                success: function (res) {
                    if (res.success === true) {
                        updatedDataController.state.editedId = "-1";
                        updatedDataController.notifyUpdate();
                        updatedDataController.fetchLeadDetails();
                    } else {
                        updatedDataController.notifyFailedResponse(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/sales-desk/login";
                    }
                }


            })
        }
    }

    deleteLeadApi = (props) => {
        let deleteRowViewController = this.state.data;
        let deleteApiViewController = this;
        var deleteConstructorVariables = this;

        if (props.id == "") {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
            deleteRowViewController.splice(props.id, 1);
        } else {
            $.ajax({
                url: "/salesdesk-api/delete-lead-detail",
                async: false,
                method: 'POST',
                data: {
                    projectId: localStorage.getItem('currentProjectId'),
                    contactNumber: props.contactNumber,
                    id: props.id
                },
                headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
                success: function (res) {

                    if (res.success === true) {

                        deleteApiViewController.setState({ deleteRow: true });
                        deleteConstructorVariables.setState({ hideDeletePopup: false });
                        deleteConstructorVariables.notifyDelete();
                        deleteRowViewController.splice(props.id, 1);
                    } else {
                        deleteRowViewController.notifyError();
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/sales-desk/login";
                    }
                }
            });
        }

        if (this.state.deleteRow) {
            this.state.data.splice(props.id, 1);
        }
        deleteConstructorVariables.fetchLeadDetails();


    }

    downloadAllLeadsApi = () => {
        var downloadController = this;

        $.ajax({
            url: "/salesdesk-api/download-all-leads",
            async: false,
            method: 'POST',
            data: {
                projectId: localStorage.getItem('currentProjectId')
            },
            headers: {

                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    const b64Data = res.result.data;
                    const blob = downloadController.b64toBlob(b64Data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8', 512)
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = res.result.fileName;
                    document.body.appendChild(link);
                    link.click();
                } else {
                    downloadController.notifyError();
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/sales-desk/login";
                }
            }

        });
    }
    b64toBlob = (b64Data, contentType, sliceSize) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }

    validateCells(value) {
        if ((value == "")) {
            this.notifyEmptyTagKeyFields();
            return false;
        }
        else {
            return true;
        }
    }

    makeCelledit(props, e) {
        this.markAsBeingEdited(this.state.data[props.index].id);
    }

    markAsBeingEdited(id) {
        this.state.editedId = id;
        var stateObj = this.state;
        this.setState(stateObj);
    }

    queryHandleChange = (event) => {
        var contactNumber = document.getElementById("contactNumber").value;
        if (contactNumber != '') {
            if (contactNumber.includes("+91")) {
                contactNumber = document.getElementById("contactNumber").value.replace("+91", "");
            }
            if (contactNumber.length == 10) {
                this.fetchLeadByContactNumber();
            } else {
                this.notifyFailedResponse("Oops! Please enter the proper contact number");
            }

        }
        else {
            this.notifyFailedResponse("Oops! Please enter the proper contact number");
        }
    }

    refreshData = (id) => {
        var refreshContent = this
        refreshContent = this.state.editedId = id;
        this.setState({ data: [], disabled: false});
        this.fetchLeadDetails();
    }

    notifyEmptyTagKeyFields() {
        toast(<b >Please change the tag field</b>, {
            position: "bottom-center",
            color: "#007aff"
        });
    }

    notifyFailedResponse(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"

        });
    }

    notifyUpdate() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Lead detail updated successfully</b>, {
            position: "top-center",
        });
    }

    notifyDelete() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Lead detail deleted successfully</b>, {
            position: "top-center",
        });
    }

    notifyError() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            contactNumber="" />&nbsp;&nbsp;Oops! Error occurred.Please try again</b>, {
            position: "top-center"
        });
    }

    notifyLeadNotPresent(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center"
        });
    }


    render() {
        const { data } = this.state
        this.dataColumn = [
            {
                Header: <b>Name</b>,
                textAlign: 'screenLeft',
                accessor: 'name',
                sortable: false,
                headerStyle: { marginLeft: '10px' },
                Cell: props => {
                    return (
                        <div name="name">
                            <div className="textarea"
                                style={{
                                    background: 'white', height: '5%',
                                    resize: 'none', borderBottom: 'none', paddingLeft: '2px', paddingTop: '6px',
                                    border: (props.original.id == this.state.editedId || props.original.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == this.state.editedId || props.original.id == "") ? '2px' : 'none'
                                }}
                                id={"name" + props.index}
                                class="form-control"
                                rows="1"
                                contentEditable={!((props.original.id == "") ? false :
                                    props.original.id != this.state.editedId) ? "plaintext-only" : false}
                            >
                                {props.original.name}
                            </div>
                        </div>
                    )
                },
            },

            {
                Header: () => <b>Email</b>,
                accessor: 'email',
                sortable: false,
                headerStyle: { marginLeft: '10px', },
                Cell: props => (
                    <div name="email">
                        <div className="textarea"
                            style={{
                                background: 'white', height: '5%',
                                resize: 'none', borderBottom: 'none', paddingLeft: '2px', paddingTop: '6px',
                                border: (props.original.id == this.state.editedId || props.original.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == this.state.editedId || props.original.id == "") ? '2px' : 'none'
                            }}
                            id={"email" + props.index}
                            class="form-control"
                            rows="1"
                            contentEditable={!((props.original.id == "") ? false :
                                props.original.id != this.state.editedId) ? "plaintext-only" : false}
                        >
                            {props.original.email}
                        </div>
                    </div>
                )
            },

            {
                Header: () => <b>Phone Number</b>,
                accessor: 'contactNumber',
                sortable: false,
                headerStyle: { marginLeft: '10px', },
                Cell: props => (
                    <div name="contactNumber">
                        <div className="textarea"
                            style={{
                                background: 'white', height: '5%',
                                resize: 'none', borderBottom: 'none', paddingLeft: '2px', paddingTop: '6px',
                                border: (props.original.id == this.state.editedId || props.original.id == "") ? 'none' : 'none', borderRadius: (props.original.id == this.state.editedId || props.original.id == "") ? '2px' : 'none'
                            }}
                            id={"contactNumber" + props.index}
                            value={props.original.contactNumber}
                            class="form-control"
                            rows="1"
                            // contentEditable={!((props.original.id == "") ? false :
                            //     props.original.id != this.state.editedId) ? "plaintext-only" : false}
                            contentEditable="false"
                        >
                            {this.state.maskLeadNumbers ? 'XXXXXXXXXX' : props.original.contactNumber}
                        </div>
                    </div>
                )
            },

            {
                Header: () => <b>Title</b>,
                accessor: 'title',
                sortable: false,
                headerStyle: { marginLeft: '10px', },
                Cell: props => (
                    <div name="title">
                        <div className="textarea"
                            style={{
                                background: 'white', height: '5%',
                                resize: 'none', borderBottom: 'none', paddingLeft: '2px', paddingTop: '6px',
                                border: (props.original.id == this.state.editedId || props.original.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == this.state.editedId || props.original.id == "") ? '2px' : 'none'
                            }}
                            id={"title" + props.index}
                            class="form-control"
                            rows="1"

                            contentEditable={!((props.original.id == "") ? false :
                                props.original.id != this.state.editedId) ? "plaintext-only" : false}
                        >
                            {props.original.title}
                        </div>
                    </div>
                )
            },


            {
                Header: () => <b>Organization</b>,
                accessor: 'companyName',
                sortable: false,
                headerStyle: { marginLeft: '10px', },
                Cell: props => (
                    <div name="companyName">
                        <div className="textarea"
                            style={{
                                background: 'white', height: '5%',
                                resize: 'none', borderBottom: 'none', paddingLeft: '2px', paddingTop: '6px',
                                border: (props.original.id == this.state.editedId || props.original.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == this.state.editedId || props.original.id == "") ? '2px' : 'none'
                            }}
                            id={"companyName" + props.index}
                            class="form-control"
                            rows="1"
                            contentEditable={!((props.original.id == "") ? false :
                                props.original.id != this.state.editedId) ? "plaintext-only" : false}
                        >
                            {props.original.companyName}
                        </div>
                    </div>
                )
            },

            {
                Header: () => <b> Enterprise CRM ID </b>,
                accessor: 'enterpriseCrmId',
                sortable: false,
                headerStyle: { marginLeft: '10px', },
                Cell: props => (
                    <div name="enterpriseCrmId">
                        <div className="textarea"
                            style={{
                                background: 'white', height: '5%',
                                resize: 'none', borderBottom: 'none', paddingLeft: '2px', paddingTop: '6px',
                                border: (props.original.id == this.state.editedId || props.original.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == this.state.editedId || props.original.id == "") ? '2px' : 'none'
                            }}
                            id={"enterpriseCrmId" + props.index}
                            class="form-control"
                            rows="1"
                            contentEditable={!((props.original.id == "") ? false :
                                props.original.id != this.state.editedId) ? "plaintext-only" : false}
                        >
                            {props.original.enterpriseCrmId}
                        </div>
                    </div>
                )
            },


            {
                Header: <b>Action</b>,
                accessor: 'action',
                filterable: false,
                flexGrow: 1,
                sortable: false,
                Cell: props => (
                    <div id="action">

                        {/* <button className='btn navyblue-btn' style={{ height: '2vw', width: '8vw', marginBottom: '0.8vw' }}
                            onClick={e => this.showTransferLeads(props, e)}>Transfer Lead</button> */}

                        <button style={{ backgroundColor: "#ffffff", border: "none" }} >
                            <img className="img-responsive"
                                title={(props.original.id == "") ||
                                    (this.state.data[props.index].id == this.state.editedId) ? 'Save' : 'Edit'}
                                style={{ marginBottom: '-0.3vw', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px', height: '1.7vw' }}
                                src={(props.original.id == "") ? this.saveImageSrc : ((props.original.id != this.state.editedId) ? this.editImageSrc : this.saveImageSrc)}
                                onClick={(e) => {
                                    (props.original.id == "") ? this.updateLeadApi(props, e) : (props.original.id == this.state.editedId) ?
                                        this.updateLeadApi(props, e) : this.makeCelledit(props, e);
                                }} />
                        </button>


                        <button style={{
                            backgroundColor: "#ffffff", border: "none"
                        }} title="Delete">
                            <img className="img-responsive" src={"./assets/images/baseline_delete_white_24dp.png"}
                                style={{ marginBottom: '-0.3vw', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px', height: '1.7vw' }}
                                onClick={() => (props.original.id) === '' ?
                                    this.fetchLeadDetails() :
                                    this.setState({
                                        hideDeletePopup: true, deletePropIndex: props.index, propsId: props.original
                                    })} /></button>
                    </div>)
            },
        ]

        return (
            <div>
                <div style={{ background: "#F9F9FB" }}
                >
                    {/* for toaster */}
                    <link rel="stylesheet" href="assets/css/ReactToastify.css" />

                    {/* for reactTable */}
                    <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                    <link rel="stylesheet" href="assets/css/toggleButton.css" />

                    {/*for dialog component */}
                    <link href="assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="assets/css/screenResolution.css" rel="stylesheet" />

                    {/*links for css files used for popup */}
                    <link href="assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="assets/css/screenResolution.css" rel="stylesheet" />
                    <div className="wrapper">
                        <div className="row" style={{ marginLeft: "0.5vw" }}>
                            <div className="col-sm-6" >
                                <h6 className="nav-item" style={{ color: '#282a65' }}>
                                    My Leads
                                </h6>
                            </div>

                            <div className="col-sm-5" Align="right">
                                <input className="border-none" type="search" placeholder="Search by number"
                                    aria-label="Search"
                                    style={{
                                        width: '12vw', height: '100%',
                                        filterable: true, backgroundColor: 'white',
                                        font: 'bold', color: 'black'
                                    }} id="contactNumber" />
                                <button onClick={this.queryHandleChange} style={{
                                    border: 'none', height: '100%',
                                    backgroundColor: 'white'
                                }}>
                                    <img src="assets/images/search.svg"
                                        style={{ width: '18px', cursor: 'pointer' }} /></button>

                                {/* <button className="btn2 table-action-button "
                                    title="Download sample xls"
                                    style={{ marginTop: '1.2vw', height: "40px", marginLeft: "4vw" }}
                                    onClick={() => {
                                        this.downloadAllLeadsApi();
                                    }}
                                >Download All Leads</button> */}
                            </div>

                            <div className="col-sm-1" >

                                <button className="btn action-button"
                                    style={{ marginLeft: '2vw' }}
                                    onClick={this.refreshData}
                                    title="Refresh">
                                    <img src="./assets/images/refresh_white_24dp.png" />
                                </button>

                            </div>

                        </div>

                        <div className="email">
                            <div className="container-fluid">
                                <div className="row" style={{ marginTop: '1%' }}>
                                    <div className="col-lg-12 ">
                                        <div className="card">
                                            <ReactTable
                                                data={this.state.data}
                                                columns={this.dataColumn}
                                                defaultPageSize={5}
                                                pageSizeOptions={[5, 10, 15]}
                                                onPageChange={this.onPageChange}
                                            />
                                        </div>
                                        <ToastContainer className="Toast-at-center" />


                                    </div>
                                </div>
                            </div>
                            {/*Dialog Component For Deletion Confirmation*/}
                            <DialogComponent width='400px' animationSettings={this.settings}
                                header='Delete Confirmation' showCloseIcon={true} buttons={this.buttons}
                                ref={dialog => this.dialogInstance = dialog}
                                visible={this.state.hideDeletePopup} close={this.dialogClose}>
                                <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                                    content="" />&nbsp;Do you want to delete the Lead detail?
                                Note: Press 'Yes' to delete or press 'No' to decline.
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</DialogComponent>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default MyLeads;


// WEBPACK FOOTER //
// ./src/sales-desk/projectmgmt/MyLeads.js